// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"d0c512f0","382":"163340be","508":"f8037695"}[chunkId] + ".chunk.js";
};